import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapTemplate } from '@zep/types';
import { Stack } from '@zep/ui';
import { TemplateCard } from '../MapTemplateModal/TemplateCard';
import { SpaceSettingsForm } from '../SpaceSettingsForm';
import S from './SpaceCreateSettingModal.module.scss';
export const SpaceCreateSettingContent = ({
  isLoadingSubmit,
  selectedTemplate
}: {
  isLoadingSubmit: boolean;
  selectedTemplate?: Pick<MapTemplate, 'name' | 'thumbnailUrl' | 'categories'>;
}) => {
  const {
    t
  } = useTranslation(['common']);
  return <Stack gap={24} className={S.content} data-sentry-element="Stack" data-sentry-component="SpaceCreateSettingContent" data-sentry-source-file="SpaceCreateSettingContent.tsx">
      {selectedTemplate && <div>
          <p className="text-subtitle mb-[8px] font-semibold text-gray-900">
            {t('common:createSpace.selectedTemplate')}
          </p>
          <TemplateCard template={{
        name: selectedTemplate.name,
        thumbnailUrl: selectedTemplate.thumbnailUrl,
        categories: selectedTemplate.categories,
        hashId: '',
        createdAt: new Date().toISOString()
      }} variant="mobileSetting" />
        </div>}
      <SpaceSettingsForm disabled={isLoadingSubmit} data-sentry-element="SpaceSettingsForm" data-sentry-source-file="SpaceCreateSettingContent.tsx" />
    </Stack>;
};